import { OperationsItemWire } from 'app/area/experience-transfer/operations/types';
import { OperationsListItem } from 'app/area/experience-transfer/operations/types-store';
import { Value } from 'app/types-shared';

export const mapOperationsList = (listWire: OperationsItemWire[]): OperationsListItem[] =>
  listWire?.length > 0
    ? listWire.map(item => ({
      id: item?.v,
      active: item?.active,
      description: item?.d
    }))
    : [];

export const mapUpdateOperations = (listWire: OperationsListItem[]): Value[] =>
  (listWire ?? [])
    .filter(f => !!f.active)
    .map(item => ({
      v: item.id,
      d: item.description
    }));
